import { PlayerProperty, Save, Restore } from '../PlayerProperty';
import IPlayerData from '../../IPlayerData';
import { IPlayerState } from '../../../State/Player/IPlayerState';
import { restoreBoolean } from '../../ParseHelper';

type PlayerStateKey = 'hasShortcut';
type PlayerDataKeys = 'hasShortcut';
export default class HasShortcut implements PlayerProperty<
    PlayerStateKey,
    PlayerDataKeys
> {
    public isChanged(
        playerStateData: IPlayerState,
        playerEndpointData: IPlayerData
    ): boolean {
        return (
            playerEndpointData.hasShortcut !==
            Number(playerStateData.hasShortcut)
        );
    }

    public restore(playerEndpointData: IPlayerData): Restore<PlayerStateKey> {
        return restoreBoolean(playerEndpointData.hasShortcut, false);
    }

    public save(playerStateData: IPlayerState): Save<PlayerDataKeys> {
        return {
            hasShortcut: Number(playerStateData.hasShortcut),
        };
    }
}
